import { onReady } from './util/onReady';

function toggleNav(show: boolean, navbar: HTMLElement, logo: HTMLElement, peg: HTMLElement) {
    navbar.classList.toggle('active', show);
    logo.classList.toggle('hide', show);
    peg.classList.toggle('visible', show);
}

function toggleLabel(show: boolean, labelELementInLogo: HTMLElement, labelElementInTopMenuContainer: HTMLElement) {
    labelELementInLogo.classList.toggle('show', show);
    labelElementInTopMenuContainer.classList.toggle('hide', show);
}

function initParallax() {
    if (document.querySelector('.js-parallax') === null) return;

    const logo = document.querySelector('.original') as HTMLElement;
    const navbar = document.querySelector('.business-review-nav') as HTMLElement;
    const origY = logo.offsetTop;
    const peg = document.querySelector('.peg') as HTMLElement;
    let lastY = window.scrollY;
    const focusElements = document.querySelectorAll('[data-js-focus-listener]');
    const labelElementInTopMenu = document.querySelector('.business-review-label') as HTMLElement;
    const labelElementInTopMenuContainer = document.querySelector('.business-review-label-container') as HTMLElement;
    const labelElementInLogo = document.querySelector('.business-review-label-in-logo-parallax') as HTMLElement;

    focusElements.forEach((el) => el.addEventListener('focus', scrollToShowNav));

    function scrollToShowNav() {
        if (lastY < origY) {
            window.scrollTo({
                top: origY,
                behavior: 'smooth',
            });
        }
    }

    document.addEventListener('scroll', () => {
        const newY = window.scrollY;
        const up = newY < lastY;
        const down = newY > lastY;
        lastY = newY;

        const scrollStream = {
            y: newY,
            up: up,
            down: down,
        };

        if (scrollStream.down && scrollStream.y >= logo.offsetTop && !navbar.classList.contains('active'))
            toggleNav(true, navbar, logo, peg);

        if (
            scrollStream.up &&
            scrollStream.y + navbar.offsetHeight <= origY + logo.offsetHeight &&
            navbar.classList.contains('active')
        )
            toggleNav(false, navbar, logo, peg);

        if (!navbar.classList.contains('active')) {
            let delta: string | number = origY - scrollStream.y;

            // The logo should never be able to disappear from the screen-
            if (delta <= 0) delta = 0;

            // And the logo should never be lower than its original point.
            if (delta >= origY || scrollStream.y <= 30) delta = '';

            logo.style.top = typeof delta === 'number' ? `${delta}px` : '';
        }

        if (labelElementInTopMenuContainer) {
            const top = labelElementInTopMenu.getBoundingClientRect().top + window.scrollY;
            const elementHeight = labelElementInTopMenu.offsetHeight;
            const labelDelta = top + elementHeight;

            toggleLabel(scrollStream.y > labelDelta, labelElementInLogo, labelElementInTopMenuContainer);
        }
    });

    /*
     *   Initially, if the scroll is lower than the logo, then we need to
     *   activate the local navigation and ensure the logo is at the top of
     *   its container.
     */
    if (window.scrollY >= origY) {
        toggleNav(true, navbar, logo, peg);
    }
}

onReady(() => {
    initParallax();
});
